import { StaticAnnouncement } from '@/components/static-announcement'
import { Icons } from '@/theme/Images'
import { useAuth } from '@/contexts/auth.context'

const FinancialAccountClosedBanner = () => {
  const { user } = useAuth()
  return (
    user?.isFinancialAccountClosed?.() && (
      <div className={'md:mx-[10%] md:mt-[2%] bg-bgGray md:m-0 mx-6 mt-6'}>
        <div className="flex flex-col md:gap-8 gap-5">
          <StaticAnnouncement
            startIcon={Icons.grayNotificationIcon}
            text={
              <>
                Your account has been closed. For assistance, contact&nbsp;
                <a className="font-semibold text-brand-500" href="mailto:help@fasten.cc">
                  help@fasten.cc
                </a>
              </>
            }
          />
        </div>
      </div>
    )
  )
}

export default FinancialAccountClosedBanner
